<div class="model-3d-viewer-wrapper" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
  <!-- Toolbar -->
  <div class="viewer-toolbar">
    <span class="viewer-title">
      <mat-icon>view_in_ar</mat-icon>
      3D Model Viewer
      <span *ngIf="fileName" class="file-name">— {{ fileName }}</span>
    </span>

    <div class="toolbar-actions">
      <!-- Animation selector -->
      <ng-container *ngIf="animationNames.length > 0">
        <select class="anim-select" [ngModel]="currentAnimationIndex" (ngModelChange)="playAnimation($event)">
          <option *ngFor="let name of animationNames; let i = index" [value]="i">{{ name }}</option>
        </select>
      </ng-container>

      <button mat-icon-button matTooltip="Reset camera" (click)="resetCamera()">
        <mat-icon>center_focus_strong</mat-icon>
      </button>

      <!-- File open button — hidden in embedded (src) mode -->
      <ng-container *ngIf="!src">
        <button mat-flat-button color="primary" (click)="fileInput.click()">
          <mat-icon>folder_open</mat-icon>
          Open file
        </button>
        <input #fileInput type="file" accept=".fbx,.glb,.gltf" hidden (change)="onFileSelected($event)" />
      </ng-container>
    </div>
  </div>

  <!-- Canvas container -->
  <div class="canvas-container">
    <canvas #rendererCanvas></canvas>

    <!-- Loading spinner -->
    <div *ngIf="isLoading" class="overlay">
      <mat-spinner
        diameter="56"
        [mode]="loadProgress !== null ? 'determinate' : 'indeterminate'"
        [value]="loadProgress ?? 0"
      ></mat-spinner>
      <p>Loading model{{ loadProgress !== null ? ' — ' + loadProgress + '%' : '…' }}</p>
    </div>

    <!-- Error message -->
    <div *ngIf="loadError" class="overlay error-overlay">
      <mat-icon class="error-icon">{{ sizeExceeded ? 'warning' : 'error_outline' }}</mat-icon>
      <p>{{ loadError }}</p>
    </div>

    <!-- Drop-zone hint shown when no model is loaded and not loading (only in standalone mode) -->
    <div *ngIf="!src && !fileName && !isLoading && !loadError" class="drop-hint">
      <mat-icon class="drop-icon">upload_file</mat-icon>
      <p>Drag &amp; drop an <strong>.fbx / .glb / .gltf</strong> file here<br />or click <strong>Open file</strong></p>
    </div>
  </div>
</div>
